import { useCallback, useContext, useEffect, useState, useRef } from 'react';
import { InterfaceContext } from '../model/InterfaceProvider';
import { statesList, staticRegions } from '../model/StaticVariables';
import Modal, { ModalBackground } from './Modal';
import TEXTS from '../controller/TextVariables';
import MapContext from '../controller/MapProvider';
import DownloadContext from '../controller/DownloadProvider';
import Waiting from './Waiting';
import { useAfterInit } from '../controller/useAfterInit';
import DragContainer from './DragContainer';
import { useMouseDown } from '../controller/useMouseDown';
import { pointWithinDomElement } from '../controller/CollisionDetection';

const DownloadModal = (props) => {
    const { setBbox } = useContext(MapContext);
    const regionDropdownElement = useRef();
    const { scope, download_modal, closeDownloadModal, setForceMap, tab, loadStatus, usState, tract, setSelectedState, setDownloadRegion } = useContext(InterfaceContext);
    const { label, maplabel, datalabel, titleCheck, legendCheck, currentMap, currentData, select_state, usmap, button } = TEXTS.modals.download;
    const { csv, setcsv_option, map, setmap_option, filter, setFilter_option, setState_option, downloading, init_download, set_csv_link, set_map_link, set_doc_link, csv_link, map_link, doc_link } = useContext(DownloadContext);
    const [valid, setValid] = useState(true);
    const pixelCoords = [0, 0];
    const [localusState, setLocalusState] = useState(usState);
    const [localMapCheck, setLocalMapCheck] = useState(tab.slug === 'map');
    const [localDataCheck, setLocalDataCheck] = useState(tab.slug === 'data');
    const [localTitleCheck, setLocalTitleCheck] = useState(true);
    const [localLegendCheck, setLocalLegendCheck] = useState(true);
    const [disablePR, setDisablePR] = useState(false);
    const [isDragging, setIsDragging] = useState(false);
    const lastClick = useMouseDown();
    const windowRef = useRef();
    const [pose, setPose] = useState({ x: 0, y: 0 });
    const [dragOffset, setDragOffset] = useState({ x: 0, y: 0 });

    const validateForm = useCallback(() => {
        const validFilter = filter !== 'state' || localusState != '';
        return validFilter;
    }, [filter, localusState]);

    const onRadioClick = (e) => {
        clearLinks();
        setValid(true);
        setFilter_option(e.target.getAttribute('value'));
        setState_option(false);
    };
    const onMapClick = (e) => {
        clearLinks();
        setmap_option(!localMapCheck);
        setLocalMapCheck(!localMapCheck);
    };
    const onDataClick = (e) => {
        clearLinks();
        setcsv_option(!localDataCheck);
        setLocalDataCheck(!localDataCheck);
    };

    const getSelectedPrintArea = (value) => {
        const selectedRegion = staticRegions.find((r) => r.id == value);
        const selectedState = statesList.find((st) => st.id == value);
        return selectedRegion || selectedState;
    };
    const selectChange = (e) => {
        clearLinks();
        setValid(true);
        setSelectedRegion(e.target.value);
    };

    const setSelectedRegion = (id) => {
        const selectedArea = getSelectedPrintArea(id); // selectedRegion || selectedState;

        if (selectedArea && selectedArea.abbr) {
            setDownloadRegion('S_' + selectedArea.id);
            setState_option(selectedArea);
            scope === 'state' && setSelectedState(selectedArea);
            setBbox(selectedArea.bounds);
        } else if (selectedArea) {
            setDownloadRegion(selectedArea.id);
            setBbox(selectedArea.bounds);
        }
    };

    const clearLinks = () => {
        set_csv_link('');
        set_map_link('');
        set_doc_link('');
    };
    const closeWindow = () => {
        clearLinks();
        closeDownloadModal();
        setFilter_option('current');
        setLocalusState(usState);
        const int = document.querySelector('#panel-map');
        int.style.height = ''; //remove height ock when window close
        setDownloadRegion(false);
        setDragOffset({ x: 0, y: 0 });
        setIsDragging(false);
    };
    const initDownload = (e) => {
        const int = document.querySelector('#panel-map');
        int.style.height = int.offsetHeight + 'px'; //lock the height to prevent the resize when closing the download dialog
        clearLinks();
        if (validateForm()) {
            const useForce = map && tab.slug !== 'map'; //if the map is not in view force it to display
            setForceMap(useForce);
            init_download();
        } else {
            setValid(false);
        }
    };
    const onTitleCheckClick = () => {
        setLocalTitleCheck(!localTitleCheck);
    };
    const onLegnedCheckClick = () => {
        setLocalLegendCheck(!localLegendCheck);
    };
    const setStartingPose = () => {
        const modalBounds = document.querySelector('#mapContainer');
        const xcoord = modalBounds.clientWidth / 2 - 150;
        const ycoord = 250;
        console.log('x,y', xcoord, ycoord);
        setPose({ x: xcoord, y: ycoord });
    };
    useEffect(() => {
        setStartingPose();
        window.addEventListener('mouseup', () => setIsDragging(false));
    }, []);

    useEffect(() => {
        setDisablePR(scope === 'national');
    }, [scope, tract]);
    //ΔVΔVΔ: Reset the radio btn to current
    useEffect(() => {
        setState_option(false);
        setFilter_option('current');
    }, [scope]);
    useEffect(() => {
        setLocalusState(usState);
    }, [usState]);
    useEffect(() => {
        if (download_modal) {
            setTimeout(() => document.querySelector('#mapCheck').focus(), 300);
            setSelectedRegion(regionDropdownElement.current.value); //set the selected region
            setStartingPose();
        }
    }, [download_modal]);

    useAfterInit(() => {
        closeWindow();
        setLocalDataCheck(tab.slug === 'data');
        setLocalMapCheck(tab.slug === 'map');
        setcsv_option(tab.slug === 'data');
        setmap_option(tab.slug === 'map');
    }, [tab]);

    const getLastClickOffset = () => {
        const dragBarRect = windowRef.current.querySelector('.win-title').getBoundingClientRect();
        return { x: dragBarRect.x - lastClick.x, y: dragBarRect.y - lastClick.y };
    };
    useEffect(() => {
        if (download_modal) {
            if (!lastClick.x || !windowRef.current) return;
            const dragbarClicked = pointWithinDomElement(lastClick.x, lastClick.y, windowRef.current.querySelector('.win-title'));
            setDragOffset(getLastClickOffset());
            setIsDragging(dragbarClicked);
        }
    }, [lastClick]);

    return (
        <>
            <DragContainer className={'download-window'} dragging={isDragging} verbose={true} offset={dragOffset} pose={pose} updateWhenScrolled="true">
                <div ref={windowRef} id={`download`} className={`info-box-pop ${download_modal ? 'show' : ''} ${downloading || !loadStatus ? 'disabled' : ''}`}>
                    <Modal pixelCoords={pixelCoords} visible={download_modal} title={label} pinned={download_modal} onClose={closeWindow}>
                        <div className="topbar">
                            <div className="download-field">
                                <input id="mapCheck" type="checkbox" checked={localMapCheck} name="mapCheck" onChange={onMapClick}></input>
                                <label htmlFor="mapCheck">{maplabel}</label>
                            </div>
                            <div className="download-field">
                                <input type="checkbox" checked={localDataCheck} name="dataCheck" onChange={onDataClick}></input>
                                <label htmlFor="dataCheck">{datalabel}</label>
                            </div>
                        </div>
                        <div className="mid-bar">
                            <div className="download-field">
                                <input id="titleCheck" type="checkbox" checked={localTitleCheck} name="titleCheck" onChange={onTitleCheckClick}></input>
                                <label htmlFor="titleCheck">{titleCheck}</label>
                            </div>
                            <div className="download-field">
                                <input type="checkbox" checked={localLegendCheck} name="legendCheck" onChange={onLegnedCheckClick}></input>
                                <label htmlFor="legendCheck">{legendCheck}</label>
                            </div>
                        </div>
                        <div className="mid-bar">
                            <h4>Geographic Comparison</h4>
                            <label>{scope === 'national' ? 'National' : 'Statewide'}</label>
                        </div>
                        <div className="mid-bar">
                            {tab.slug !== 'map' && (
                                <div className="download-field">
                                    <input type="radio" name="filter" value="current" checked={filter === 'current'} onChange={onRadioClick}></input>
                                    <label htmlFor="filter" value="current" onClick={onRadioClick}>
                                        {tab.slug === 'map' ? currentMap : currentData}
                                    </label>
                                </div>
                            )}
                            <div className="download-field">
                                <h4>Print Area</h4>
                                <select ref={regionDropdownElement} className={valid ? '' : 'invalid'} value={localusState?.id} onChange={selectChange}>
                                    {scope === 'national' && (
                                        <>
                                            <option value="">US</option>

                                            {staticRegions.map((r) => {
                                                return (
                                                    <option key={r.id} value={r.id}>
                                                        {r.label}
                                                    </option>
                                                );
                                            })}
                                        </>
                                    )}
                                    {scope !== 'national' && (
                                        <>
                                            <option value="">Select State</option>
                                        </>
                                    )}
                                    {statesList.map((st) => {
                                        return (
                                            <option key={st.id} value={st.id} disabled={st.id + '' === '72' && disablePR}>
                                                {st.label}
                                            </option>
                                        );
                                    })}
                                </select>
                            </div>
                        </div>
                        {!valid && <div className="invalid">* Please select a state</div>}
                        <button className={'icon-download'} onClick={initDownload} disabled={!localMapCheck && !localDataCheck}>
                            {button}
                        </button>
                        <Waiting visible={downloading || !loadStatus} />
                        {(csv_link || map_link || doc_link) && (
                            <div className="download-links">
                                <h4>If download does not start, please use link(s) below:</h4>
                                {csv_link && (
                                    <a href={csv_link.href} download={csv_link.download}>
                                        Download CSV
                                    </a>
                                )}
                                {doc_link && (
                                    <a href={doc_link.href} download={doc_link.download} target="_blank">
                                        Documentation
                                    </a>
                                )}
                                {map_link && (
                                    <a href={map_link.href} download={map_link.download}>
                                        Download Map
                                    </a>
                                )}
                            </div>
                        )}
                    </Modal>
                </div>
            </DragContainer>
        </>
    );
};
export default DownloadModal;

const DownloadModalBackground = () => {
    const { download_modal } = useContext(InterfaceContext);
    return <ModalBackground visible={download_modal} />;
};
export { DownloadModalBackground };
